import React, { useEffect, useState, useRef } from "react";
import './modal.css'
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import adminService from "../../services/admin.service";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import * as $ from 'jquery';

function TopicSubtopicModal(props) {
    const [topicName,setTopicName] = useState("");
    const [topicDescription,setTopicDescription] = useState("")
    const [subtopicInputValues, setSubtopicInputValues] = useState(['']);
    const { parentCallback, editMode} = props;
    const [isEdit, setIsEdit] = useState(false);
    const [show, setShow] = useState(false);
    const [showdel, setshowdel] = useState(false);
    const form = useRef();
   

    // Function to handle input field value change
    const handleInputChange = (index, value) => {
      const updatedValues = [...subtopicInputValues];
      updatedValues[index] = value;
      setSubtopicInputValues(updatedValues);
    };

    // Function to handle adding a new input field
    const addInputField = () => {
        setshowdel(true);
        setSubtopicInputValues([...subtopicInputValues, '']);
    };

    // Function to handle removing an input field
    const removeSubgroup = (e,index) => {
        e.preventDefault();
        if(typeof subtopicInputValues?.[index] === "undefined"){
            toast.error("Something wrong")
        }else if(subtopicInputValues.length === 1){
            toast.error("Indicator-Unit must have atleast one subgroup!");
        }else{
            const updatedValues = [...subtopicInputValues];
            updatedValues.splice(index, 1);
            setSubtopicInputValues(updatedValues);
        }
    };



  useEffect(() => {
    if (editMode) {
      setIsEdit(true);
      const editsubtopicArray=[]
      setTopicName(editMode?.topicname)
      setTopicDescription(editMode?.topicdescription)
      editMode?.subtopic?.map((item)=>{
        return editsubtopicArray.push(item?.subtopicname)
      })
      setSubtopicInputValues(editsubtopicArray)
    } else {
      setIsEdit(false);
      setTopicName("")
      setTopicDescription("")
      setSubtopicInputValues([""])
    }
  }, [props]);

  const openAddDataModal = () => {
    setShow(!show);
    parentCallback();
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();
    const subtopicArr=[]
    subtopicInputValues.forEach((value)=>{
      const subtopicObj={}
      subtopicObj.subtopicname=value
      subtopicArr.push(subtopicObj)
    })

    let dataToSend = {
        topicname: topicName,
        topicdescription: topicDescription,
        subtopicList: JSON.stringify(subtopicArr),
    };
    if(isEdit){
      adminService.httpPut("/data-import/generic/update/topic/" + editMode?._id, dataToSend)
      .then((res) => {
        if(res?.status == 200) {
            toast.success(res?.message);
            openAddDataModal();
        } else {
            toast.error(res?.message);
        }
        
      })
      .catch((e) => {
        toast.error("Error in adding indicator");
      });
    }else{
      adminService.httpPost("/data-import/generic/add/topic", dataToSend)
      .then((res) => {
        if(res?.status === 200){
            toast.success(res?.message);
        }
        if(res?.status == false){
            toast.error(res?.message);
        }
        console.log(res.message,"new mondal-see")
        openAddDataModal();
      })
      .catch((e) => {
        toast.error("Error in adding indicator");
      });
    }
  };

    // ====================================================== Form Validation End
    return (
        <>
            <div className="area-form">
                <ValidatorForm className="main_react_form w-100" ref={form} onSubmit={handleSubmit1}>
                    <Stack spacing={2} sx={{ width: 300 }} className="w-100">
                        <div className="gallery-collections mt-0">
                            <div className="row mb-30">
                                <div className="col-md-12">
                                    <div className="form-group mb-0 inputform_style">
                                        <div className="mat-form-field-wrapper">
                                            <span className="mat-form-field-label-wrapper">
                                                <label>Sector Name</label>
                                            </span>
                                            <TextValidator  name="goalName"  className="w-100"  onChange={(e)=>setTopicName(e.target.value)}  value={topicName}  validators={['required']}  errorMessages={['This field is required']}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-30">
                                <div className="col-md-12">
                                    <div className="form-group mb-0 inputform_style">
                                        <div className="mat-form-field-wrapper">
                                            <span className="mat-form-field-label-wrapper">
                                                <label>Sector Description</label>
                                            </span>
                                            <TextValidator name="goalDescription" className="w-100" onChange={(e)=>setTopicDescription(e.target.value)} value={topicDescription} validators={['required']} errorMessages={['This field is required']}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-30">
                                {subtopicInputValues?.map((item, index) => {
                                    return (<>
                                        <div className="col-md-10">
                                            <div className="form-group mb-0 inputform_style">
                                                <div className="mat-form-field-wrapper">
                                                    <span className="mat-form-field-label-wrapper">
                                                        <label>Sub-Sector</label>
                                                    </span>
                                                    <TextValidator  className="w-100"  key={index}  value={item}  onChange={(e) => handleInputChange(index, e.target.value)}  validators={['required']}  errorMessages={['This field is required']}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {index > 0 && <div className="col-md-2 d-flex align-items-end justify-content-end">
                                            <button className="si_delete"  onClick={(e) => removeSubgroup(e, index)}>
                                                <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.25 6.97518e-09C10.0801 -5.43467e-05 10.8788 0.317554 11.4822 0.887672C12.0856 1.45779 12.448 2.23719 12.495 3.066L12.5 3.25H17.75C17.94 3.25006 18.1229 3.32224 18.2618 3.45197C18.4006 3.5817 18.4851 3.7593 18.498 3.94888C18.511 4.13846 18.4515 4.32589 18.3316 4.4733C18.2117 4.62071 18.0402 4.7171 17.852 4.743L17.75 4.75H16.954L15.674 17.77C15.6099 18.4191 15.3171 19.0243 14.848 19.4775C14.3789 19.9306 13.7639 20.2023 13.113 20.244L12.937 20.25H5.563C4.91046 20.25 4.27919 20.0179 3.78201 19.5953C3.28482 19.1727 2.95412 18.587 2.849 17.943L2.826 17.769L1.545 4.75H0.75C0.568762 4.74999 0.393658 4.68436 0.257069 4.56523C0.120481 4.44611 0.0316483 4.28155 0.00699997 4.102L0 4C7.6429e-06 3.81876 0.0656426 3.64366 0.184767 3.50707C0.303891 3.37048 0.468446 3.28165 0.648 3.257L0.75 3.25H6C6 2.38805 6.34241 1.5614 6.9519 0.951903C7.5614 0.34241 8.38805 6.97518e-09 9.25 6.97518e-09ZM15.447 4.75H3.052L4.319 17.622C4.34705 17.9092 4.47362 18.1779 4.67722 18.3824C4.88082 18.5869 5.14892 18.7147 5.436 18.744L5.563 18.75H12.937C13.537 18.75 14.046 18.325 14.162 17.748L14.182 17.622L15.446 4.75H15.447ZM11 7.5C11.1812 7.50001 11.3563 7.56564 11.4929 7.68477C11.6295 7.80389 11.7184 7.96845 11.743 8.148L11.75 8.25V15.25C11.7499 15.44 11.6778 15.6229 11.548 15.7618C11.4183 15.9006 11.2407 15.9851 11.0511 15.998C10.8615 16.011 10.6741 15.9515 10.5267 15.8316C10.3793 15.7117 10.2829 15.5402 10.257 15.352L10.25 15.25V8.25C10.25 8.05109 10.329 7.86032 10.4697 7.71967C10.6103 7.57902 10.8011 7.5 11 7.5ZM7.5 7.5C7.68124 7.50001 7.85634 7.56564 7.99293 7.68477C8.12952 7.80389 8.21835 7.96845 8.243 8.148L8.25 8.25V15.25C8.24994 15.44 8.17776 15.6229 8.04803 15.7618C7.9183 15.9006 7.7407 15.9851 7.55112 15.998C7.36154 16.011 7.17411 15.9515 7.0267 15.8316C6.87929 15.7117 6.7829 15.5402 6.757 15.352L6.75 15.25V8.25C6.75 8.05109 6.82902 7.86032 6.96967 7.71967C7.11032 7.57902 7.30109 7.5 7.5 7.5ZM9.25 1.5C8.81081 1.50002 8.38768 1.66517 8.06461 1.96268C7.74154 2.26019 7.54214 2.6683 7.506 3.106L7.5 3.25H11C11 2.78587 10.8156 2.34075 10.4874 2.01256C10.1592 1.68437 9.71413 1.5 9.25 1.5Z" fill="#333" />
                                                </svg>
                                            </button>
                                        </div>}
                                    </>)
                                })}
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <button className="new-subgroup" type="button" onClick={() => addInputField()}
                                    >
                                        <img src="assets/lib/images/icon/plusicon.svg" alt="icon-pluse" /> Add Sub-Sector
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="gallery-sidebar-button text-center new_gallery-sidebar-button mt-0">
                            <div className="d-flex align-items-center justify-content-center">
                                <Button variant="contained"  onClick={() => { openAddDataModal(); $("#openDataModal").trigger("click"); }} className="cancelbtn">Cancel</Button>
                                <Button variant="contained" className="addbtn" type="submit">
                                    {isEdit ? 'Update' : 'Add'}
                                </Button>
                            </div>
                        </div>
                    </Stack>
                </ValidatorForm>
            </div>
        </>

    );
}

export default TopicSubtopicModal;
